<template>
  <div class="interlayer">
    <div class="container_w">
      <bread-crumb :crumbList="crumbList"></bread-crumb>
      <!-- <page-header :headerTitle="headerTitle"></page-header> -->
      <div v-html="detailHtml" class="html_box" @click="addComment($event)">

      </div>
    </div>
  </div>
</template>

<script>

import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
// import PageHeader from "@/components/PageHeader/PageHeader";
export default {
  components: {
    BreadCrumb,
    // PageHeader,
  },
  name: "interlayer",
  data() {
    return {
      crumbList: [],
      headerTitle: 'interlayer',
      detailHtml: '',
      footerList: [],
    };
  },
  props: {},
  watch: {
    '$route'(to, from) {
      // data数据操作
      this.textCheck(to.query.list)
    }
  },
  methods: {
    textCheck(j) {
      let file = null
      if (j.fileText) {
        file = j
      }else{
        file = JSON.parse(j)
      }
      // let file = JSON.parse(j)
      this.crumbList = []
      this.crumbList.push({
        name: file.title,
        url: ''
      })
      console.log('file', file)
      console.log('this.fileTextthis.fileText', file.fileText)
      this.$Ajax.get(file.fileText)
          .then((response) => {
            this.detailHtml = response.data
          })
          .catch((error) => {
            console.log(error);
          });
    },
    goUrlPage(pId) {
      let arr = [...this.footerList]
      let newData = {}
      arr.forEach((item, index) => {
        if (item.nodeTitle == "Policy") {
          item.childrens.forEach((item1) => {
            newData[item1.title] = item1
          })
        }
      })
      if (pId == '0') {
        //   cookie
        console.log(newData)
        console.log(newData['Cookies Statement'])
        // path:'/interlayer',query: {list: list}
        console.log(pId)
        this.$router.push({
          name: 'interlayer',
          query: {
            list: newData['Cookies Statement']
          }
        })

      } else {
        console.log(newData['Private Policy'])
        console.log(pId)
        this.$router.push({
          name: 'interlayer',
          query: {
            list: newData['Private Policy']
          }
        })
      }
    },
    addComment: function (event) {
      // alert("a");
      if (event.target.id === 'cookiestatment') {
        // 获取触发事件对象的属性
        this.goUrlPage('0')
      }
    }
  },
  filters: {},
  computed: {},
  created() {
    console.log(this.$route.query.list)
    // this.$Ajax.get('/Content/Scripts/SITEMAP.js')
    // .then( (response)=> {
    //     console.log(response.data)
    // })
    // .catch( (error) =>{
    //     console.log(error);
    // });

    var that = this
    this.textCheck(this.$route.query.list)
    this.footerList = FOOTERJSON[0].childrens
  },
  mounted() {
  },
    updated() {
        let targetCheckBox = document.getElementById("myCheckbox")
        let targetChecked = this.$Utils.getLocal("COOKIE_STATE") === "1"
        if (targetCheckBox) {
            targetCheckBox.checked = targetChecked
            targetCheckBox.onchange = function (_that) {
                if (targetCheckBox.checked) {
                    this.$Utils.setLocal("COOKIE_STATE", "1")
                } else {
                    this.$Utils.setLocal("COOKIE_STATE", "00")
                }
            }
        }
    },
    destroyed() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
// .interlayer{


// }
</style>
